import React, { useEffect, useState, useRef } from 'react';
import MediumEditor from 'medium-editor';

const FormFieldEditorMediumWrapper = ({ tag, options, text, onChange, onKeyDown }) => {
  const [value, setValue] = useState(text);

  const container = useRef();

  const medium = useRef();

  const Element = tag || 'div';

  const handleOnChange = ({ updatedText }) => {
    setValue(value);
    onChange?.(updatedText.replace(/&nbsp;/g, ' '), medium); // https://github.com/yabwe/medium-editor/issues/1165
  };

  useEffect(() => {
    medium.current = new MediumEditor(container.current, options);
    medium.current.subscribe('editableInput', () =>
      handleOnChange({ updatedText: container.current.innerHTML }),
    );

    return () => medium.current.destroy();
  }, [options?.disableEditing]);

  if (medium && medium.current) medium.current.saveSelection();

  return (
    <Element dangerouslySetInnerHTML={{ __html: value }} ref={container} onKeyDown={onKeyDown} />
  );
};

export default FormFieldEditorMediumWrapper;
